import { useGetMemberSummaryQuery } from '../state/api';
import { selectAllMembers } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import MembersOverview from './members-overview';

const MembersOverviewContainer = () => {
  // Fetch data with RTK Query (handles caching, loading states)
  useGetMemberSummaryQuery();

  // Use entity selector for optimized, memoized access to normalized data
  const lstMembers = useAppSelector(selectAllMembers);

  return <MembersOverview lstMembers={lstMembers} />;
};

export default MembersOverviewContainer;
